import { DeleteOutlined, EditOutlined, KeyOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, InputNumber, Layout, message, Modal, Pagination, Popconfirm, Row, Select, Space, Spin, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useEffect, useRef, useState } from "react";
import { FilterRequest, OrderTypes, OrderValue } from "../../../../utils/Filters/FilterModels";
import FilterHelper from "../../../../utils/Filters/FilterHelper";
import axiosInstance from "../../../../api/axiosInstance";
import { User } from "../../../../services/users/user";
import { useNavigate } from "react-router-dom";
import { LeaderBoard } from "../../../../services/leader-board/leader-board";
import { useWatch } from "antd/es/form/Form";
const { TextArea } = Input;
const { Content } = Layout;
const { Option } = Select;

const API_URL = process.env.REACT_APP_API_URL;

const LeaderBoardManagement = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [tableHeight, setTableHeight] = useState(500);
    const [data, setData] = useState<LeaderBoard[]>([]);
    const [searchText, setSearchText] = useState("");
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [formLeaderBoard] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [listUser, setListUsers] = useState<any[]>([]);
    const medalType = useWatch("medal", formLeaderBoard);
    const hasMedal = !!medalType;
    const [filter, setFilter] = useState<FilterRequest>(new FilterRequest({
        page: 1,
        limit: 10,
        keyword: '',
        summary: '',
        filters: [],
        orders: [
            new OrderValue({ propertyName: 'createdDate', type: OrderTypes.Desc, index: 0 }),
            new OrderValue({ propertyName: 'status', type: OrderTypes.Asc, index: 0 })
        ],
        isFull: false,
        tree: false,
    }));
    const [userfilter, setUserFilter] = useState<FilterRequest>(new FilterRequest({
        page: 1,
        limit: 1000,
        keyword: '',
        summary: '',
        filters: [],
        orders: [new OrderValue({ propertyName: 'userCode', type: OrderTypes.Desc, index: 0 })
        ],
        isFull: false,
        tree: false,
    }));

    useEffect(() => {
        const width = window.innerWidth;
        if (width <= 1366) setTableHeight(250);
        else setTableHeight(500);
    }, []);

    useEffect(() => {
        const params = FilterHelper.getParamWithFilter(filter);
        fetchLeaderBoards(params);
    }, []);

    const fetchLeaderBoards = async (paramValues?: any) => {
        try {
            setLoading(true);
            const response = await axiosInstance.get("/leader-board", {
                params: paramValues ?? filter,
            });
            const items = response.data?.list || [];
            setTotalRecords(response.data?.totalRecords || 0);
            const formattedData: LeaderBoard[] = items.map((item: any) => ({
                leaderBoardID: item.leaderBoardID,
                userCode: item.userCode,
                nickName: item.nickName,
                fullName: item.fullName,
                score: item.score,
                medal: item.medal,
                rank: item.rank,
                userID: item.userID,
                
            }));

            setData(formattedData);
        } catch (error: any) {
            console.error("Lỗi khi lấy bảng vinh danh", error.response?.data || error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyword = e.target.value.toLowerCase();
        setSearchText(keyword);

        const newFilter = new FilterRequest({
            ...filter,
            page: 1,
            keyword: keyword,
        });

        setFilter(newFilter);
        const params = FilterHelper.getParamWithFilter(newFilter);
        fetchLeaderBoards(params);
    };

    const getListUser = async (paramValues?: any) => {
        try {
            const params = FilterHelper.getParamWithFilter(userfilter);

            const response = await axiosInstance.get("/user", {
                params: params,
            });
            const listUsers = response.data?.list.map((x: any) => new User(x)) || [];
            setListUsers(listUsers)
        } catch (error) {
            message.error("Không thể tải danh sách người dùng!");
        }
    };

    const handlePaginationChange = (page: number, pageSize: number) => {
        const newFilter = new FilterRequest({
            ...filter,
            page,
            limit: pageSize,
        });
        setFilter(newFilter);
        const params = FilterHelper.getParamWithFilter(newFilter);
        fetchLeaderBoards(params);
    };
    const handleCreateLeaderBoard = () => {
        getListUser();
        setIsModalVisible(true);
    }

    const handleReloadLeaderBoard = () => {
        const params = FilterHelper.getParamWithFilter(filter);
        fetchLeaderBoards(params);
    }
    const handleEditLeaderBoard = (record: LeaderBoard) => {
        getListUser();
        setIsModalVisible(true);
        formLeaderBoard.setFieldsValue(record);
    };

    const handleDeleteLeaderBoard = async (record: LeaderBoard) => {
        try {
            await axiosInstance.put(`/leader-board/delete-leader-board`, { LeaderBoardIDs: [record.leaderBoardID] });
            message.success("Xoá bản ghi thành công!");
            const params = FilterHelper.getParamWithFilter(filter);
            fetchLeaderBoards(params);
        }
        catch (error: any) {
            message.error(error?.response?.data?.systemMessage || "Có lỗi xảy ra khi xóa.");
        }
    }

    const handleOk = async () => {
        try {
            const values = await formLeaderBoard.validateFields();
            await axiosInstance.post(`/leader-board/create-leader-board`, values);
            message.success("Tạo bản ghi thành công!");
            const params = FilterHelper.getParamWithFilter(filter);
            fetchLeaderBoards(params);
            setIsModalVisible(false);
            formLeaderBoard.resetFields();
        } catch (error: any) {
            message.error(error?.response?.data?.systemMessage || "Có lỗi xảy ra khi tạo.");
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        formLeaderBoard.resetFields();
    };

    const columns: ColumnsType<any> = [
        { title: "ID", dataIndex: "userCode", key: "userCode", width: 200 },
        { title: "NickName", dataIndex: "nickName", key: "nickName" },
        { title: "Họ và tên", dataIndex: "fullName", key: "fullName" },
        // { title: "Điểm vinh danh", dataIndex: "score", key: "score" },
        { title: "Thứ hạng", dataIndex: "rank", key: "rank" },
        { title: "Loại huy chương", dataIndex: "medal", key: "medal", render: (text: any) => (text === 3 ? "Huy chương vàng" : text === 2 ? "Huy chương bạc" : text === 1 ? "Huy chương đồng" : ""), },
        {
            title: "Hành động",
            key: "action",
            width: 150,
            render: (_: any, record: LeaderBoard) => (
                <Space>
                    <Button icon={<EditOutlined />} onClick={() => handleEditLeaderBoard(record)} />
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => handleDeleteLeaderBoard(record)}
                        okText="Có"
                        cancelText="Không"
                    >
                        <Button icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const filteredData = data.filter(
        (blog) =>
            blog?.nickName?.toLowerCase().includes(searchText)
    );

    return (
        <Content style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
            <div
                style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff",
                    zIndex: 999,
                    padding: "16px",
                    borderBottom: "1px solid #ddd",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
            >
                <Space style={{ width: "100%" }}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        style={{ backgroundColor: "#F48100", borderColor: "#F48100" }}
                        onClick={handleCreateLeaderBoard}
                    >
                        Thêm mới
                    </Button>
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={handleReloadLeaderBoard}
                    >
                        Làm mới
                    </Button>
                </Space>
                <Space style={{ width: "100%", paddingTop: "16px" }}>
                    <Input
                        style={{ width: 365 }}
                        placeholder="Tìm kiếm"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onPressEnter={(e: any) => handleSearch(e)}
                    />
                </Space>
            </div>
            <div style={{ flex: 1, overflow: "auto", marginTop: "16px" }}>
                {loading ? (
                    <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                ) : (
                    <Table
                        columns={columns}
                        onRow={(record) => ({
                            onClick: (e) => {
                                const actionColumnIndex = columns.findIndex((col) => col.key === 'action');
                                const clickedColumn = (e.target as HTMLElement).closest('td');

                                if (clickedColumn && clickedColumn.cellIndex === actionColumnIndex) {
                                    return;
                                }
                            },
                        })}
                        dataSource={filteredData}
                        pagination={false}
                        scroll={{ y: tableHeight }}
                    />
                )}
            </div>
            <div
                style={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#fff",
                    paddingTop: "10px",
                    borderTop: "-1px solid #ddd",
                    boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
                    textAlign: "center",
                }}
            >
                <Pagination
                    current={filter.page}
                    pageSize={filter.limit}
                    total={totalRecords}
                    onChange={handlePaginationChange}
                    showTotal={(total, range) =>
                        `Hiển thị ${range[0]} - ${range[1]} của ${total} bản ghi`
                    }
                />
            </div>
            <Modal
                title="Thông tin vinh danh"
                visible={isModalVisible}
                onCancel={handleCancel}
                onOk={handleOk}
                okButtonProps={{ style: { backgroundColor: "#F48100", borderColor: "#F48100" } }}
                cancelButtonProps={{ style: { backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" } }}
                okText="Xác nhận"
                cancelText="Huỷ"
                width={800}
            >
                <Form layout="vertical" form={formLeaderBoard}>
                    <Card>
                        <div className="p-6 bg-white rounded-lg shadow-md">
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item
                                                label={<strong>Chọn người vinh danh</strong>}
                                                name="userID"
                                                rules={[{ required: true, message: 'Vui lòng chọn người vinh danh' }]}
                                            >
                                                <Select
                                                    placeholder="Vui lòng chọn người vinh danh"
                                                    showSearch
                                                    filterOption={(input, option) => {
                                                        const label = `${option?.children}`.toLowerCase();
                                                        return label.includes(input.toLowerCase());
                                                    }}
                                                >
                                                    {listUser.map((user) => (
                                                        <Option key={user.id} value={user.id}>
                                                            {user.userCode} - {user.nickName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label={<strong>Loại huy chương</strong>}
                                                name="medal"
                                            >
                                                <Select
                                                    placeholder="Chọn huy chương"
                                                    allowClear
                                                    onClear={() => {
                                                        formLeaderBoard.setFieldValue("rank", undefined);
                                                    }}
                                                    // onChange={(value) => {
                                                    //     if (value === 3) {
                                                    //         formLeaderBoard.setFieldsValue({ rank: 1 });
                                                    //     } else if (value === 2) {
                                                    //         formLeaderBoard.setFieldsValue({ rank: 2 });
                                                    //     } else if (value === 1) {
                                                    //         formLeaderBoard.setFieldsValue({ rank: 3 });
                                                    //     }
                                                    // }}
                                                >
                                                    <Option value={3}>Huy chương vàng</Option>
                                                    <Option value={2}>Huy chương bạc</Option>
                                                    <Option value={1}>Huy chương đồng</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={16}>
                                        {/* <Col span={12}>
                                            <Form.Item
                                                label={<strong>Thứ hạng</strong>}
                                                name="rank"
                                                rules={
                                                    hasMedal
                                                        ? [] // Không required nếu có huy chương
                                                        : [{ required: true, message: "Vui lòng nhập thứ hạng" }]
                                                }
                                            >
                                                <Input
                                                    placeholder="Nhập thứ hạng"
                                                    disabled={hasMedal}
                                                />
                                            </Form.Item>
                                        </Col> */}
                                        <Col span={12}>
                                            <Form.Item
                                                label={<strong>Thứ tự</strong>}
                                                name="rank"
                                                rules={[{ required: true, message: 'Vui lòng nhập thứ tự' }]}
                                            >
                                                <InputNumber placeholder="Nhập thứ tự" type="number"
                                                    style={{ width: "100%" }}
                                                    min={0}
                                                    step={1}/>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </Form>
            </Modal>
        </Content>
    )
}
export default LeaderBoardManagement